module.exports = __webpack_public_path__ + "img/icon-error-ani.2f05a24d.svg";